import { observable } from 'mobx';
import { FeaturedVideo } from '../../components/project-happy/utilities/types';
import { LOAD_STATE } from '../../types/api';

export class WebContentModel {
  @observable
  featuredVideosStatus: LOAD_STATE = LOAD_STATE.EMPTY;

  @observable
  featuredVideos: FeaturedVideo[] = [];
}
